module.exports = __webpack_public_path__ + "static/img/03013C_1_2_C_20210310_LC.c4a8e34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/03013C_1_2_C_20210310_LC.png
// module id = 2Y6H
// module chunks = 0